import { render, staticRenderFns } from "./OfficeHoursSection.vue?vue&type=template&id=3fa0c695&"
import script from "./OfficeHoursSection.vue?vue&type=script&lang=js&"
export * from "./OfficeHoursSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports